import PropTypes from 'prop-types'
import _ from 'lodash'

import { actionCreators } from '.'

export default PropTypes.shape(
  _.mapValues(actionCreators, () => PropTypes.func.isRequired)
).isRequired
